var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 250,
    viewBox: "0 0 346 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 39.4231,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 47.1154,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 54.8077,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 62.5,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 70.1924,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 77.8846,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 85.577,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92222,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.61119,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9889,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6777,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.3667,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0555,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.7445,
    cy: 93.2693,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 184.484,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 192.177,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 199.869,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 207.561,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 215.254,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 222.946,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 230.638,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.405,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.093,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.782,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.471,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.16,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.849,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.538,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.227,
    cy: 238.331,
    rx: 1.92222,
    ry: 1.92308,
    fill: "#DEE2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7789 197V171.242H5.76667V146.638L58.0511 62.8289H92.2667V148.944H109.182V171.242H92.2667V197H64.7789ZM28.8333 148.944H64.7789V92.6233H62.8567L28.8333 148.944ZM172.925 199.307C155.369 199.307 142.362 193.22 133.904 181.046C125.446 168.871 121.217 151.828 121.217 129.914C121.217 108.001 125.446 90.9574 133.904 78.7833C142.362 66.6093 155.369 60.5222 172.925 60.5222C190.481 60.5222 203.488 66.6093 211.946 78.7833C220.404 90.9574 224.633 108.001 224.633 129.914C224.633 151.828 220.404 168.871 211.946 181.046C203.488 193.22 190.481 199.307 172.925 199.307ZM172.925 174.894C180.614 174.894 185.932 172.075 188.879 166.437C191.827 160.798 193.3 152.853 193.3 142.601V117.228C193.3 106.976 191.827 99.0307 188.879 93.3922C185.932 87.7537 180.614 84.9344 172.925 84.9344C165.236 84.9344 159.918 87.7537 156.97 93.3922C154.023 99.0307 152.549 106.976 152.549 117.228V142.601C152.549 152.853 154.023 160.798 156.97 166.437C159.918 172.075 165.236 174.894 172.925 174.894ZM295.295 197V171.242H236.283V146.638L288.568 62.8289H322.783V148.944H339.699V171.242H322.783V197H295.295ZM259.35 148.944H295.295V92.6233H293.373L259.35 148.944Z",
    fill: "#4C94FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M244.101 32.3571L225.717 50.7494",
    stroke: "#DEE2E6",
    strokeWidth: 2.00013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.101 50.7494L225.717 32.3571",
    stroke: "#DEE2E6",
    strokeWidth: 2.00013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1088 206.744L18.7246 225.136",
    stroke: "#DEE2E6",
    strokeWidth: 2.00013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1088 225.136L18.7246 206.744",
    stroke: "#DEE2E6",
    strokeWidth: 2.00013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.36ea47c02af439075312232000805c40.svg";
export { ForwardRef as ReactComponent };